import cn from 'classnames';
import React from 'react';
import { InputMeta } from '.';
import './input.scss';

export const InputWrapper: React.FC<
  React.PropsWithChildren & InputMeta & { className?: string; fullWidth?: boolean }
> = ({ error, warning, showError, className, children, fullWidth = true }) => {
  return (
    <div className={cn('input--wrapper', { 'w-full': fullWidth }, className)}>
      <div className="input--inner">{children}</div>
      {showError && error && <div className="input--error">{error}</div>}
      {!error && warning && <div className="input--warning">{warning}</div>}
    </div>
  );
};
